import Layout from '@/layout/index.vue';
import { ordersDispatchesSubMenu } from './subMenus/orders-dispatches-sub-menu';
import { inventoryInwardSubMenu } from './subMenus/inventory-inwards-sub-menu';
const inventoryRouter = {
  path: '/inventory',
  component: Layout,
  redirect: 'noredirect',
  name: 'inventoryManagement.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Unit Manager', 'Invoice Manager', 'Agent', 'Branch Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager'],
    title: 'inventoryManagement.title',
    icon: 'truck'
  },
  children: [...inventoryInwardSubMenu, ...ordersDispatchesSubMenu]
};
export default inventoryRouter;